import React from "react";
import { Row, Col } from 'react-bootstrap';
//import Img from "gatsby-image";


const SpeakerItem = ({ speaker }) => {

  const {
    field_heading,
    field_subhead,
    field_desc,
    field_twitter,
    field_insta,
    field_linkedin,
  } = speaker;

  const image = speaker.relationships.field_image;

  return (
    <>
      <div className="speaker-item speaker-item__keynote-speaker">
        {
          (!!image && !!image.relationships.field_media_image.localFile) &&
            <div className="speaker__portrait">
              <img 
                src={ image.relationships.field_media_image.localFile.publicURL } 
                alt="Speaker portrait" />
            </div>
        }

        <div className="speaker__name d-flex align-items-center justify-content-center">{ field_heading }</div>
        <div className="speaker__bio">
          <div className="d-flex align-items-center justify-content-between">

            {
              field_subhead &&
                <div className="speaker__occupation">{ field_subhead }</div>
            }

            <div className="speaker__socials d-flex">

              { field_linkedin &&
                <a href={ field_linkedin.uri }><div className="speaker__social-linkedin icon"></div></a>
              }

              { field_insta &&
                <a href={ field_insta.uri }><div className="speaker__social-insta icon"></div></a>
              }

              { field_twitter &&
                <a href={ field_twitter.uri }><div className="speaker__social-twitter icon"></div></a>
              }
            </div>
          </div>
          <div className="speaker__desc" dangerouslySetInnerHTML={{ __html: field_desc.processed }}></div>

        </div>
      </div>
    </>
  );

}

const KeynoteSpeakers = ({speakers}) => {

  return (
    <>
      <Row className="speakers-list d-flex justify-content-lg-around">
      {
        speakers.map((speaker, speakerIndex) => (
          <Col xs={12} lg={4} className="d-flex"><SpeakerItem speaker={speaker} key={speakerIndex} /></Col>
        ))
      }
      </Row>
    </>
);

}

// export means another page can import it and use it
export default KeynoteSpeakers;
